module.exports = __webpack_public_path__ + "static/media/teygja_aftanverdlaeri_a.76d5b6b4.png";